module.exports = __webpack_public_path__ + "img/puntos.0934d1d8.svg";